/* ============================================================
   ns-ochugen-lp.js: お中元・夏ギフト2026 LP
   機能:
   1) クーポン CP500 自動適用(/discount/CP500 を叩いて discount cookie をセット)+コードコピー
   2) 商品カード → クイックビュー(画像ギャラリー / バリアント選択 / のし選択 / 数量 / カート投入)
      - 追従CTAバー: 説明をスクロール中も価格・クーポン後価格・カート投入ボタンが下部に固定表示
      - バリアントを選び直すと、その種類の写真へメイン画像を切替(商品ページと同じ挙動)
      - のしは snippets/noshi-options.liquid と同じ line item properties
        (のし / のし種類 / 表書き / 名入れ)で /cart/add.js に渡す
   3) 下部ドック: スクロール後CTA(カート空) ⇔ カートバー(カート有)
      - 「CP500適用中」はカートにLP対象商品(12品のバリアント)がある時だけ表示
      - 表示中は body.nsog-dock-active で Shopify Inbox / MrPoint を上へ退避
   4) スクロールリビール
   JSが無効・失敗した場合、カード内リンクは通常の商品ページ遷移として機能する。
   更新: 2026-07-03(v4: 対象19品に拡大)
        2026-07-10(バリアント選択で写真を切替 / 先頭画像は snippets/nsog-lead-image.liquid が決定)
        2026-07-31(受付7/31終了の4品をLPから除外し14品へ。表示文言の「19品」を「14品」に統一
                   ※7/15の18品化の際に取り残されていた表記もここで解消)
        2026-08-07(販売終了の2品をLPから除外し12品へ。関連する表示文言を統一)
        2026-10-01(のしの掛け方を外のし固定に。内のしの選択欄を廃止し、のし種類=外のし を固定で送る
                   ※商品ページ側 snippets/noshi-options.liquid と同じ扱い。変える時は両方そろえる)
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-nsog-root]');
  if (!root) return;
  var COUPON = root.getAttribute('data-nsog-code') || 'CP500';

  function h(tag, cls, attrs) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { el.setAttribute(k, attrs[k]); });
    return el;
  }
  function yen(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  /* LP対象商品(12品)の全バリアントID。ドックの「CP500適用中」判定に使う。
     テンプレのカードから動的に収集するので、掲載商品を増減してもここは自動追従する */
  var LP_VARIANT_IDS = {};
  document.querySelectorAll('script[data-nsog-variants]').forEach(function (js) {
    try {
      JSON.parse(js.textContent).forEach(function (v) { LP_VARIANT_IDS[Number(v.id)] = true; });
    } catch (e) { /* 解析不能なカードはスキップ */ }
  });

  /* ============================================================
     1) クーポン自動適用 + コピー
     ============================================================ */
  var couponState = document.querySelector('[data-nsog-coupon-state]');
  function markApplied() {
    if (!couponState) return;
    couponState.textContent = 'クーポン取得済み。対象12品は1点ごとに500円引きされます。';
    couponState.classList.add('is-applied');
  }
  try {
    if (sessionStorage.getItem('nsogCoupon') === '1') {
      markApplied();
    } else {
      fetch('/discount/' + encodeURIComponent(COUPON), { credentials: 'same-origin' })
        .then(function (r) {
          if (r.ok || r.redirected) {
            sessionStorage.setItem('nsogCoupon', '1');
            markApplied();
          }
        })
        .catch(function () { /* 失敗時は手入力案内のまま */ });
    }
  } catch (e) { /* sessionStorage不可の環境は初期表示のまま */ }

  document.querySelectorAll('[data-nsog-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var done = function () {
        var t = btn.textContent;
        btn.textContent = 'コピーしました';
        setTimeout(function () { btn.textContent = t; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(COUPON).then(done).catch(done);
      } else { done(); }
    });
  });

  /* ============================================================
     2) クイックビュー
     ============================================================ */
  var overlay = null, panel = null, els = {}, lastFocus = null;
  var currentCard = null, currentVariants = [], currentVariant = null;
  var gallery = null; // 開いているクイックビューの画像ギャラリー { main, srcs, thumbs }

  var NOSHI_OMOTEGAKI = ['御中元', '暑中御見舞', '残暑御見舞', '御祝', '御礼', '無地(表書きなし)'];
  var NOSHI_KAKE = '外のし'; // 掛け方は外のし固定(選択欄なし)。注文明細の「のし種類」にこの値を入れる

  function buildUI() {
    overlay = h('div', 'nsog-qv-overlay', { 'data-nsog-overlay': '', hidden: '' });
    panel = h('div', 'nsog-qv', { role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'nsog-qv-title', tabindex: '-1' });

    var omoteOptions = NOSHI_OMOTEGAKI.map(function (o) {
      return '<option value="' + o + '">' + o + '</option>';
    }).join('');

    // 構造: .nsog-qv(flex列) > close(絶対) + scroll(唯一のスクロール領域) + ctabar(実フッター)
    // iOS対策: スクロールは単一の overflow-y:auto 要素に集約し、footerは sticky でなく flex子で常時表示。
    panel.innerHTML =
      '<button type="button" class="nsog-qv__close" data-nsog-close aria-label="閉じる">×</button>' +
      '<div class="nsog-qv__scroll" data-nsog-scroll>' +
        '<div class="nsog-qv__body">' +
          '<div class="nsog-qv__media" data-nsog-media></div>' +
          '<div class="nsog-qv__main">' +
            '<h3 class="nsog-qv__title" id="nsog-qv-title" data-nsog-title></h3>' +
            '<div class="nsog-qv__pricerow">' +
              '<span class="nsog-qv__price" data-nsog-price></span>' +
              '<span class="nsog-qv__after" data-nsog-after></span>' +
            '</div>' +
            '<p class="nsog-qv__couponnote">「クーポンで」の価格は、クーポンCP500(対象商品1点につき500円引き)を適用した目安です。</p>' +
            '<div class="nsog-qv__variant" data-nsog-variantwrap hidden>' +
              '<label for="nsog-qv-variant">種類を選ぶ</label>' +
              '<select id="nsog-qv-variant" data-nsog-variantsel></select>' +
            '</div>' +
            '<div class="nsog-qv__egift" data-nsog-egift hidden>' +
              '<div class="nsog-qv__egift-mount" data-nsog-egift-mount></div>' +
            '</div>' +
            '<div class="nsog-qv__noshi" data-nsog-noshi>' +
              '<label class="nsog-qv__noshi-toggle">' +
                '<input type="checkbox" data-nsog-noshi-toggle>' +
                '<span class="nsog-qv__noshi-lead">のし紙・名入れをする</span>' +
                '<span class="nsog-qv__noshi-free">無料</span>' +
              '</label>' +
              '<p class="nsog-qv__noshi-lede">お中元・ご贈答に。表書き・名入れも指定できます。</p>' +
              '<div class="nsog-qv__noshi-fields">' +
                '<div class="nsog-qv__noshi-row">' +
                  '<span class="nsog-qv__noshi-label">掛け方</span>' +
                  '<p class="nsog-qv__noshi-fixed">外のし(外側に掛ける形)でお付けします</p>' +
                '</div>' +
                '<div class="nsog-qv__noshi-row">' +
                  '<label for="nsog-noshi-omote">表書き</label>' +
                  '<select id="nsog-noshi-omote" data-nsog-noshi-omote>' + omoteOptions + '</select>' +
                '</div>' +
                '<div class="nsog-qv__noshi-row">' +
                  '<label for="nsog-noshi-name">名入れ(差出人名・任意)</label>' +
                  '<input id="nsog-noshi-name" type="text" maxlength="30" placeholder="例：岩手太郎(空欄なら名入れなし)" data-nsog-noshi-name>' +
                '</div>' +
                '<p class="nsog-qv__noshi-note">選択内容はご注文情報として配送時に反映されます。のし紙(掛け紙)を無料でお付けします。</p>' +
              '</div>' +
            '</div>' +
            '<div class="nsog-qv__links">' +
              '<a class="nsog-qv__pdp" data-nsog-pdp href="#">商品ページでさらに詳しく →</a>' +
            '</div>' +
            '<div class="nsog-qv__desc" data-nsog-desc></div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="nsog-qv__ctabar">' +
        '<div class="nsog-qv__bartop">' +
          '<p class="nsog-qv__feedback" data-nsog-feedback role="status" aria-live="polite" hidden></p>' +
          '<button type="button" class="nsog-qv__barclose" data-nsog-close aria-label="閉じる">×&nbsp;閉じる</button>' +
        '</div>' +
        '<button type="button" class="nsog-qv__noshicta" data-nsog-noshi-jump aria-label="のし紙・名入れ(無料)を設定する">' +
          '<span class="nsog-qv__noshicta-badge" aria-hidden="true">熨斗</span>' +
          '<span class="nsog-qv__noshicta-txt">' +
            '<b data-nsog-noshi-cta-lead>のし紙・名入れをする</b>' +
            '<small data-nsog-noshi-cta-sub>お中元・ご贈答に無料対応</small>' +
          '</span>' +
          '<span class="nsog-qv__noshicta-act" data-nsog-noshi-cta-act>設定する</span>' +
        '</button>' +
        '<div class="nsog-qv__buy" data-nsog-buy>' +
          '<div class="nsog-qv__barprice">' +
            '<span data-nsog-bar-price></span>' +
            '<em data-nsog-bar-after hidden></em>' +
          '</div>' +
          '<div class="nsog-qv__qty">' +
            '<button type="button" class="nsog-qv__step" data-nsog-dec aria-label="数量を減らす">−</button>' +
            '<input class="nsog-qv__qtyinput" data-nsog-qty type="number" min="1" max="99" step="1" value="1" aria-label="数量">' +
            '<button type="button" class="nsog-qv__step" data-nsog-inc aria-label="数量を増やす">＋</button>' +
          '</div>' +
          '<button type="button" class="nsog-qv__add" data-nsog-add>カートに入れる</button>' +
        '</div>' +
        '<a class="nsog-qv__proceed" data-nsog-proceed href="/cart" hidden>ご注文へ進む →</a>' +
        '<div class="nsog-qv__soldout" data-nsog-soldout hidden>ただいま在庫切れです</div>' +
      '</div>';

    overlay.appendChild(panel);
    document.body.appendChild(overlay);

    els = {
      scroll: panel.querySelector('[data-nsog-scroll]'),
      media: panel.querySelector('[data-nsog-media]'),
      title: panel.querySelector('[data-nsog-title]'),
      price: panel.querySelector('[data-nsog-price]'),
      after: panel.querySelector('[data-nsog-after]'),
      barPrice: panel.querySelector('[data-nsog-bar-price]'),
      barAfter: panel.querySelector('[data-nsog-bar-after]'),
      variantWrap: panel.querySelector('[data-nsog-variantwrap]'),
      variantSel: panel.querySelector('[data-nsog-variantsel]'),
      egiftWrap: panel.querySelector('[data-nsog-egift]'),
      egiftMount: panel.querySelector('[data-nsog-egift-mount]'),
      noshi: panel.querySelector('[data-nsog-noshi]'),
      noshiToggle: panel.querySelector('[data-nsog-noshi-toggle]'),
      noshiCta: panel.querySelector('[data-nsog-noshi-jump]'),
      noshiCtaLead: panel.querySelector('[data-nsog-noshi-cta-lead]'),
      noshiCtaSub: panel.querySelector('[data-nsog-noshi-cta-sub]'),
      noshiCtaAct: panel.querySelector('[data-nsog-noshi-cta-act]'),
      noshiOmote: panel.querySelector('[data-nsog-noshi-omote]'),
      noshiName: panel.querySelector('[data-nsog-noshi-name]'),
      buy: panel.querySelector('[data-nsog-buy]'),
      soldout: panel.querySelector('[data-nsog-soldout]'),
      qty: panel.querySelector('[data-nsog-qty]'),
      add: panel.querySelector('[data-nsog-add]'),
      proceed: panel.querySelector('[data-nsog-proceed]'),
      feedback: panel.querySelector('[data-nsog-feedback]'),
      pdp: panel.querySelector('[data-nsog-pdp]'),
      desc: panel.querySelector('[data-nsog-desc]')
    };

    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeQV(); });
    panel.querySelectorAll('[data-nsog-close]').forEach(function (b) { b.addEventListener('click', closeQV); });
    panel.querySelector('[data-nsog-dec]').addEventListener('click', function () { stepQty(-1); });
    panel.querySelector('[data-nsog-inc]').addEventListener('click', function () { stepQty(1); });
    els.add.addEventListener('click', onAdd);
    els.variantSel.addEventListener('change', function () {
      var v = currentVariants.filter(function (x) { return String(x.id) === els.variantSel.value; })[0];
      if (v) { applyVariant(v); showVariantImage(v); mountEgift(v.available ? v.id : null); }
    });
    els.noshiToggle.addEventListener('change', syncNoshiCta);
    els.noshiCta.addEventListener('click', onNoshiJump);
  }

  /* のしのON/OFFに応じて、のしブロックと追従バーの「のし誘導ボタン」の表示を同期する */
  function syncNoshiCta() {
    var on = els.noshiToggle.checked;
    els.noshi.classList.toggle('is-on', on);
    if (!els.noshiCta) return;
    els.noshiCta.classList.toggle('is-on', on);
    els.noshiCtaLead.textContent = on ? 'のし紙・名入れを設定中' : 'のし紙・名入れをする';
    els.noshiCtaSub.textContent = on ? '内容を確認・変更できます' : 'お中元・ご贈答に無料対応';
    els.noshiCtaAct.textContent = on ? '設定済 ✓' : '設定する';
  }

  /* 追従バーの「のし紙・名入れをする」を押したとき:
     未チェックなら自動でONにし、のしセクションへスクロール＋点滅で注目喚起する */
  function onNoshiJump() {
    if (!els.noshiToggle.checked) els.noshiToggle.checked = true;
    syncNoshiCta();
    scrollToNoshi();
    // 最初の入力欄(表書き)へフォーカス(スクロールは奪わない)。a11y向上＋操作導線を明確化
    try { els.noshiOmote.focus({ preventScroll: true }); } catch (e) { /* 古い環境は無視 */ }
  }

  /* のしセクションを .nsog-qv__scroll 内で上部付近まで滑らかにスクロールし、点滅させる */
  function scrollToNoshi() {
    var sc = els.scroll, target = els.noshi;
    if (!sc || !target) return;
    var top = sc.scrollTop + (target.getBoundingClientRect().top - sc.getBoundingClientRect().top) - 14;
    if (top < 0) top = 0;
    try { sc.scrollTo({ top: top, behavior: 'smooth' }); }
    catch (e) { sc.scrollTop = top; }
    // アニメーションを毎回頭から再生させるため一旦外してリフローを挟む
    target.classList.remove('is-flash');
    void target.offsetWidth;
    target.classList.add('is-flash');
    setTimeout(function () { target.classList.remove('is-flash'); }, 2100);
  }

  function normQty(v) {
    var n = parseInt(v, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > 99) n = 99;
    return n;
  }
  function stepQty(d) { els.qty.value = normQty(normQty(els.qty.value) + d); }

  function resetFeedback() {
    els.feedback.hidden = true;
    els.feedback.textContent = '';
    els.feedback.classList.remove('is-error');
  }
  function showFeedback(msg, isError) {
    els.feedback.textContent = msg;
    els.feedback.classList.toggle('is-error', !!isError);
    els.feedback.hidden = false;
  }

  /* ============================================================
     eギフト(All in gift)をポップアップ内にオンデマンド設置
     - 公式コンポーネントを公式パラメータ data-product-variant-id で都度マウント
       (バックエンドのリバースはせず、公式ウィジェットにそのまま処理させる)
     - 「eギフトで贈る」選択時のみ、当方制御で のし/カート追加 を隠す(分岐は自前)
     - All in gift 未読込・失敗時も通常フローは無傷(try/catchで隔離)
     ============================================================ */
  function syncEgiftBranch(c) {
    var eg = c && c.querySelector('input[value="eGift"]');
    var isE = !!(eg && eg.checked);
    if (panel) panel.classList.toggle('nsog-qv--egift', isE);
  }

  function mountEgift(variantId) {
    try {
      if (!els.egiftMount) return;
      els.egiftMount.innerHTML = '';
      if (panel) panel.classList.remove('nsog-qv--egift');
      els.egiftWrap.hidden = true;
      if (!variantId || !window.AllInGift || !window.AllInGift.product) return;
      var c = document.createElement('div');
      c.className = 'sns-gift-product-container';
      c.setAttribute('data-product-variant-id', String(variantId));
      els.egiftMount.appendChild(c);
      // ウィジェット内ラジオ(値 none/eGift)の変更を委譲監視し、eギフト選択で通常配送UIを隠す
      c.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) syncEgiftBranch(c);
      });
      window.AllInGift.product({}).mount(c);
      els.egiftWrap.hidden = false;
      setTimeout(function () { syncEgiftBranch(c); }, 60);
    } catch (e) { /* eギフト設置失敗時は通常フローのみで継続 */ }
  }

  function applyVariant(v) {
    currentVariant = v;
    els.price.textContent = yen(v.price);
    els.barPrice.textContent = yen(v.price);
    if (v.price > 50000) {
      els.after.textContent = 'クーポンで ' + yen(v.price - 50000);
      els.after.hidden = false;
      els.barAfter.textContent = 'クーポンで ' + yen(v.price - 50000);
      els.barAfter.hidden = false;
    } else {
      els.after.hidden = true;
      els.barAfter.hidden = true;
    }
    var ok = !!v.available;
    els.buy.hidden = !ok;
    els.soldout.hidden = ok;
    els.add.disabled = !ok;
    if (els.noshiCta) els.noshiCta.hidden = !ok;
    // バリアント変更時は「ご注文へ進む」を隠して通常状態に戻す
    if (els.proceed) els.proceed.hidden = true;
  }

  function fillDetail(card) {
    els.media.innerHTML = '';
    els.desc.innerHTML = '';
    gallery = null;
    var tpl = card.querySelector('template[data-nsog-detail]');
    if (!tpl) { els.media.innerHTML = '<div class="nsog-qv__noimg">画像準備中</div>'; return; }
    var frag = tpl.content.cloneNode(true);
    var srcs = [].slice.call(frag.querySelectorAll('.nsog-qv__srcimg'))
      .map(function (im) { return im.getAttribute('src'); }).filter(Boolean);
    buildGallery(srcs);
    var descSrc = frag.querySelector('.nsog-qv__descsrc');
    if (descSrc && descSrc.innerHTML.trim()) {
      els.desc.innerHTML = descSrc.innerHTML;
    } else {
      els.desc.innerHTML = '<p>この商品の詳しい説明は商品ページでご覧いただけます。</p>';
    }
  }

  function thumbSrc(src) {
    return src.indexOf('width=') > -1 ? src.replace(/width=\d+/, 'width=140') : src;
  }
  function buildGallery(srcs) {
    if (!srcs.length) { els.media.innerHTML = '<div class="nsog-qv__noimg">画像準備中</div>'; return; }
    var main = h('img', 'nsog-qv__mainimg');
    main.src = srcs[0];
    main.alt = els.title.textContent;
    els.media.appendChild(main);
    gallery = { main: main, srcs: srcs, thumbs: [] };
    if (srcs.length > 1) {
      var strip = h('div', 'nsog-qv__thumbs');
      srcs.forEach(function (src, i) {
        var btn = h('button', 'nsog-qv__thumb' + (i === 0 ? ' is-active' : ''), { type: 'button', 'aria-label': '画像' + (i + 1) });
        var t = h('img');
        t.src = thumbSrc(src);
        t.alt = '';
        btn.appendChild(t);
        btn.addEventListener('click', function () {
          main.src = src;
          strip.querySelectorAll('.nsog-qv__thumb').forEach(function (x) { x.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
        strip.appendChild(btn);
        gallery.thumbs.push(btn);
      });
      els.media.appendChild(strip);
    }
  }

  /* バリアントを選び直したとき、そのバリアントの写真をメインに出す(商品ページと同じ挙動)。
     商品ページ(Warehouse)は「開いた直後=商品の1枚目」「ユーザーがバリアントを変えた時だけ切替」なので、
     ここも openFromCard では呼ばず、種類セレクトの change でのみ呼ぶ。
     (1枚目は 2026-07-07 に贈答箱へ整えた featured_image なので、開口時は意図どおり維持される)
     - v.image が null (バリアントに画像未設定=単一バリアント商品) → 現在の表示を保つ
     - v.image がギャラリー(先頭6枚)の外 → サムネは無選択のままメイン画像だけ差し替える */
  function showVariantImage(v) {
    if (!gallery || !v || !v.image) return;
    if (gallery.main.getAttribute('src') === v.image) return;
    gallery.main.setAttribute('src', v.image);
    var i = gallery.srcs.indexOf(v.image);
    gallery.thumbs.forEach(function (btn, j) { btn.classList.toggle('is-active', j === i); });
  }

  function openFromCard(card) {
    if (!overlay) buildUI();
    resetFeedback();
    currentCard = card;

    els.title.textContent = card.getAttribute('data-title') || '';
    els.pdp.href = card.getAttribute('data-url') || '#';
    els.qty.value = 1;
    els.noshiToggle.checked = false;
    els.noshi.classList.remove('is-flash');
    syncNoshiCta();
    els.noshiName.value = '';
    els.noshiOmote.selectedIndex = 0;

    // バリアント
    currentVariants = [];
    try {
      var js = card.querySelector('script[data-nsog-variants]');
      if (js) currentVariants = JSON.parse(js.textContent);
    } catch (e) { currentVariants = []; }

    if (currentVariants.length > 1) {
      els.variantSel.innerHTML = currentVariants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
          v.title + '｜' + yen(v.price) + (v.available ? '' : '(在庫切れ)') + '</option>';
      }).join('');
      var firstOk = currentVariants.filter(function (v) { return v.available; })[0] || currentVariants[0];
      els.variantSel.value = String(firstOk.id);
      els.variantWrap.hidden = false;
      applyVariant(firstOk);
    } else if (currentVariants.length === 1) {
      els.variantWrap.hidden = true;
      applyVariant(currentVariants[0]);
    } else {
      els.variantWrap.hidden = true;
      els.buy.hidden = true;
      els.soldout.hidden = false;
      if (els.noshiCta) els.noshiCta.hidden = true;
    }

    // eギフト(All in gift): 在庫のある現バリアントで設置(無ければ非表示)
    mountEgift((currentVariants.length && currentVariant && currentVariant.available) ? currentVariant.id : null);

    fillDetail(card);

    if (els.proceed) els.proceed.hidden = true;

    lastFocus = document.activeElement;
    overlay.hidden = false;
    document.documentElement.classList.add('nsog-qv-open');
    document.addEventListener('keydown', onKey, true);
    // 前回のスクロール位置をリセット(スクロール領域は .nsog-qv__scroll に一本化)
    if (els.scroll) els.scroll.scrollTop = 0;
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      panel.focus();
    });
  }

  function closeQV() {
    if (!overlay || overlay.hidden) return;
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('nsog-qv-open');
    document.removeEventListener('keydown', onKey, true);
    // eギフトの後始末(マウント済みウィジェットを破棄し通常状態へ戻す)
    try {
      if (els.egiftMount) els.egiftMount.innerHTML = '';
      if (els.egiftWrap) els.egiftWrap.hidden = true;
      if (panel) panel.classList.remove('nsog-qv--egift');
    } catch (e) { /* noop */ }
    setTimeout(function () { overlay.hidden = true; }, 240);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) { if (e.key === 'Escape') closeQV(); }

  /* カート投入 */
  function onAdd() {
    if (!currentVariant || els.add.disabled) return;
    var qty = normQty(els.qty.value);
    els.qty.value = qty;
    els.add.disabled = true;
    els.add.classList.add('is-loading');
    resetFeedback();

    var item = { id: Number(currentVariant.id), quantity: qty };
    if (els.noshiToggle.checked) {
      item.properties = {
        'のし': '希望する',
        'のし種類': NOSHI_KAKE,
        '表書き': els.noshiOmote.value
      };
      if (els.noshiName.value.trim()) item.properties['名入れ'] = els.noshiName.value.trim();
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (res) {
      els.add.disabled = false;
      els.add.classList.remove('is-loading');
      if (!res.ok) {
        showFeedback((res.data && (res.data.description || res.data.message)) ||
          'カートに追加できませんでした。時間をおいて再度お試しください。', true);
        return;
      }
      showFeedback('カートに追加しました。', false);
      // バー内に「ご注文へ進む」を出す(下部ドックを探さなくてもその場で進める)
      if (els.proceed) els.proceed.hidden = false;
      return refreshCart();
    }).catch(function () {
      els.add.disabled = false;
      els.add.classList.remove('is-loading');
      showFeedback('通信エラーが発生しました。時間をおいて再度お試しください。', true);
    });
  }

  /* クリック委譲: カード内 [data-nsog-open] とおすすめ枠 [data-nsog-open-handle] */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var byHandle = e.target.closest('[data-nsog-open-handle]');
    if (byHandle) {
      var target = document.querySelector('[data-nsog-card][data-handle="' + byHandle.getAttribute('data-nsog-open-handle') + '"]');
      if (target) { e.preventDefault(); openFromCard(target); }
      return;
    }
    var trigger = e.target.closest('[data-nsog-open]');
    if (!trigger) return;
    var card = trigger.closest('[data-nsog-card]');
    if (!card) return;
    e.preventDefault();
    openFromCard(card);
  });

  /* ============================================================
     3) 下部ドック(CTA ⇔ カートバー)
     「CP500適用中」はカートにLP対象商品がある時だけ表示する
     ============================================================ */
  var dock = null, dockCartView = null, dockCtaView = null;
  var dockCount = null, dockChip = null, dockText = null, dockNote = null;
  var cartCount = 0, eligibleCount = 0, dockEnabled = false;

  function buildDock() {
    dock = h('div', 'nsog-dock', { 'data-nsog-dock': '', hidden: '' });
    dock.innerHTML =
      '<div class="nsog-dock__panel" data-nsog-dock-cta>' +
        '<div class="nsog-dock__info"><span class="nsog-dock__chip">500円OFF</span><span>このページの12品・先着200名様</span></div>' +
        '<a class="nsog-dock__btn" href="#lineup">ギフトを選ぶ</a>' +
      '</div>' +
      '<div class="nsog-dock__panel" data-nsog-dock-cart hidden>' +
        '<div class="nsog-dock__info">' +
          '<span class="nsog-dock__chip" data-nsog-dock-chip>' + COUPON + '適用中</span>' +
          '<span data-nsog-dock-text>カートに<b data-nsog-cart-count>0</b>点</span>' +
          '<span class="nsog-dock__note" data-nsog-dock-note hidden>500円OFFはこのページの12品のみ</span>' +
        '</div>' +
        '<a class="nsog-dock__btn" href="/cart">ご注文へ進む</a>' +
      '</div>';
    document.body.appendChild(dock);
    dockCtaView = dock.querySelector('[data-nsog-dock-cta]');
    dockCartView = dock.querySelector('[data-nsog-dock-cart]');
    dockChip = dock.querySelector('[data-nsog-dock-chip]');
    dockText = dock.querySelector('[data-nsog-dock-text]');
    dockNote = dock.querySelector('[data-nsog-dock-note]');
    dockCount = dock.querySelector('[data-nsog-cart-count]');
  }

  function renderDock() {
    if (!dock) buildDock();
    var hasCart = cartCount > 0;
    dockCtaView.hidden = hasCart;
    dockCartView.hidden = !hasCart;
    if (hasCart) {
      if (eligibleCount > 0) {
        dockChip.hidden = false;
        dockNote.hidden = true;
        dockText.innerHTML = 'カートに<b>' + cartCount + '</b>点・対象' + eligibleCount + '点が500円OFF';
      } else {
        dockChip.hidden = true;
        dockNote.hidden = false;
        dockText.innerHTML = 'カートに<b>' + cartCount + '</b>点';
      }
    }
    var show = dockEnabled || hasCart;
    dock.hidden = false;
    dock.classList.toggle('is-shown', show);
    document.body.classList.toggle('nsog-dock-active', show);
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartCount = cart.item_count || 0;
        eligibleCount = 0;
        (cart.items || []).forEach(function (it) {
          if (LP_VARIANT_IDS[Number(it.variant_id)]) eligibleCount += it.quantity || 0;
        });
        renderDock();
        // テーマ(Warehouse)のヘッダーカート数を更新
        try {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (e) { /* noop */ }
      })
      .catch(function () { /* 取得失敗時は表示を変えない */ });
  }

  // FVを過ぎたらCTAドックを出す
  var fv = document.getElementById('fv');
  if (fv && 'IntersectionObserver' in window) {
    var fvIO = new IntersectionObserver(function (entries) {
      dockEnabled = !entries[0].isIntersecting;
      renderDock();
    }, { threshold: 0 });
    fvIO.observe(fv);
  } else {
    dockEnabled = true;
  }
  refreshCart();

  /* ============================================================
     4) スクロールリビール(JS起動時のみ初期非表示を有効化)
     ============================================================ */
  var reveals = document.querySelectorAll('.nsog-reveal');
  if ('IntersectionObserver' in window) {
    root.classList.add('nsog-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ============================================================
     5) 追従目次ナビ(.nsog-fnav) — 南部鉄瓶LPと同方式の簡易版
        - スクロールが window.innerHeight*0.6 を超えたら .is-visible で出現
        - SP: トグルでドロワー開閉 / 閉じるボタンで折り畳み→縦タブで復帰
        - 画面内で最も上のセクションのリンクを .is-active でハイライト
     ============================================================ */
  (function initFollowNav() {
    var nav = document.querySelector('[data-nsog-fnav]');
    if (!nav) return;
    var mqMobile = function () { return window.matchMedia('(max-width: 768px)'); };

    // 5-1) スクロールで表示
    var showAt = window.innerHeight * 0.6;
    var rafId = null;
    function updateVis() {
      if (window.scrollY > showAt) nav.classList.add('is-visible');
      else nav.classList.remove('is-visible');
      rafId = null;
    }
    function onScroll() { if (rafId == null) rafId = window.requestAnimationFrame(updateVis); }
    updateVis();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { showAt = window.innerHeight * 0.6; onScroll(); }, { passive: true });

    // 5-2) SPトグル開閉
    var toggle = nav.querySelector('[data-nsog-fnav-toggle]');
    var panel = nav.querySelector('.nsog-fnav__panel');
    function openPanel() { nav.classList.add('is-open'); if (toggle) toggle.setAttribute('aria-expanded', 'true'); }
    function closePanel() {
      if (nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    }
    if (toggle && panel) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (nav.classList.contains('is-open')) closePanel(); else openPanel();
      });
      document.addEventListener('click', function (e) {
        if (nav.classList.contains('is-open') && !nav.contains(e.target)) closePanel();
      });
      // パネル内リンクをタップしたらSPでは閉じる(スムーズスクロールの邪魔をしない)
      nav.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a[href^="#"]') && mqMobile().matches) closePanel();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
      var mm = mqMobile();
      if (mm.addEventListener) mm.addEventListener('change', closePanel);
      else if (mm.addListener) mm.addListener(closePanel);
    }

    // 5-3) 折り畳み↔復帰
    var closeBtn = nav.querySelector('[data-nsog-fnav-close]');
    var reopenBtn = document.querySelector('[data-nsog-fnav-reopen]');
    if (closeBtn && reopenBtn) {
      closeBtn.addEventListener('click', function () {
        closePanel();
        nav.classList.add('is-collapsed');
        reopenBtn.hidden = false;
        window.requestAnimationFrame(function () { reopenBtn.classList.add('is-visible'); });
      });
      reopenBtn.addEventListener('click', function () {
        nav.classList.remove('is-collapsed');
        reopenBtn.classList.remove('is-visible');
        setTimeout(function () { reopenBtn.hidden = true; }, 320);
      });
    }

    // 5-4) 現在地ハイライト(画面内で最も上のセクションを is-active に)
    var links = [].slice.call(nav.querySelectorAll('.nsog-fnav__sections a'));
    var pairs = links.map(function (a) {
      var id = (a.getAttribute('href') || '').slice(1);
      return { a: a, el: id ? document.getElementById(id) : null };
    }).filter(function (p) { return p.el; });
    if (pairs.length && 'IntersectionObserver' in window) {
      var visible = [];
      function setActive(el) {
        pairs.forEach(function (p) { p.a.classList.toggle('is-active', p.el === el); });
      }
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var idx = visible.indexOf(en.target);
          if (en.isIntersecting) { if (idx === -1) visible.push(en.target); }
          else if (idx !== -1) { visible.splice(idx, 1); }
        });
        if (visible.length) {
          visible.sort(function (a, b) { return a.offsetTop - b.offsetTop; });
          setActive(visible[0]);
        }
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      pairs.forEach(function (p) { obs.observe(p.el); });
    }
  })();
})();
